<template>
  <div
    :class="
      !this.$store.getters.iframeColidee
        ? 'Vuecontainer'
        : 'background-colidee  Vuecontainer'
    "
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
.background-colidee {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue